<template>
  <div id="popup-company" class="popup__main">
    <div class="popup__header">
      <a href="#" class="popup__close" @click.prevent="closePopup"></a>
    </div>
    <div class="popup__content">
      <div class="chart">
        <img src="../assets/images/popup_chart-2.png" alt="" />
        <!-- <picture>
          <source
            srcset="../assets/images/popup_chart-2_m.png"
            media="(max-width: 1080px)"
          />
          <img src="../assets/images/popup_chart-2.png" alt="" />
        </picture> -->
      </div>
      <div class="secure-text">
        資料時間：2025/8/31。資料來源：法盛投資管理，中國信託投信整理。<span
          class="highlight"
          >若內容涉及個股、類股或產業，僅為參考舉例，不代表個股、類股或產業推薦，且不為未來投資獲利之保證，亦不一定為基金未來之持股。投資人申購本基金係持有基金受益憑證，而非本文提及之投資資產或標的。</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';

export default {
  name: 'PopupCompany',
  data: () => {
    return {};
  },
  computed: {
    ...mapState(useMainStore, ['popup']),
  },
  methods: {
    ...mapActions(useMainStore, ['closePopup']),
  },
  mounted() {},
  components: {},
};
</script>

<style lang="scss">
#popup-company {
  .chart {
    // overflow-x: auto;
    display: flex;
    justify-content: center;
    width: 100%;
    // max-width: 1200px;
    // height: 545px;
    @include tablet {
      // width: vwM(1000);
      // height: vwM(700);
      // margin-left: vwM(62);
      margin-top: vwM(40);
    }
    img {
      width: 1105px;
      // height: 505px;
      // @include tabletX {
      //   width: vwX(1105);
      //   height: vwX(534);
      // }
      @include mobile {
        width: vwM(1105);
        // height: vwM(534);
      }
      @include tablet {
        // width: vwM(1350);
        // height: vwM(617);
        width: vwM(885);
      }
    }
  }
  .secure-text {
    color: #3f3f3f;
    margin: 0 auto;
    .highlight {
      color: #009eb5;
    }
  }
}
</style>
